const ToogleMenu = function() {
    function ToogleMenu() {
        this.selector = {
            toggles: document.querySelectorAll('.accordion-toggle')
        }
        this.load();
    }
    ToogleMenu.prototype.load = function() {
        var _ = this;
        if(_.selector.toggles.length > 0) {
            _.selector.toggles.forEach(toggle => {
                toggle.addEventListener('click', event => {
                const accordionToggle = event.target.closest('.accordion-toggle');
                  if(accordionToggle) {
                    if(accordionToggle.getAttribute('aria-expanded') === 'false') {
                        accordionToggle.setAttribute('aria-expanded', 'true');
                        accordionToggle.nextElementSibling.classList.remove('closed');
                    } else {
                        accordionToggle.setAttribute('aria-expanded', 'false');
                        accordionToggle.nextElementSibling.classList.add('closed');
                    }
                  }
                })
            })
        }
    }
    ToogleMenu = new ToogleMenu;
}
ToogleMenu();